import { ApiSet, BaseResponse, useDownloadApi } from 'utils/network/api_hooks'
import { Form } from 'utils/hooks'
import { CraifHttpClient } from '../utils/network/axios'

export type InventoryExportSearchParams = {
    year?: number
    month?: number
}

export function useFetchInventoryExportApi(searchForm: Form<InventoryExportSearchParams>): ApiSet<BaseResponse> & { execute: () => void } {
    const apiPath = 'inventory_exports/'
    const api = useDownloadApi<BaseResponse>(new CraifHttpClient(), {
        initialResponse: {},
    })

    const execute = (): void => {
        api.execute(apiPath, 'inventory.xlsx', searchForm.object)
    }

    return { ...api, execute: execute }
}
